import React, { useState, useEffect } from "react";

function VATCalculator() {
  const [amount, setAmount] = useState("");
  const [vatRate, setVATRate] = useState(15);
  const [VATAmount, setVATAmount] = useState(null);
  const [includingVat, setIncludingVat] = useState(null);
  const [excludingVat, setExcludingVat] = useState(null);
  const [excludingVatAmount, setExcludingVatAmount] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const calculateTotal = () => {
    const amt = parseFloat(amount);
    const rate = parseFloat(vatRate);
    if (isNaN(amt) || isNaN(rate) || amt <= 0) return;

    const calculatedVAT = (amt * rate) / 100;
    const totalIncludingVat = amt + calculatedVAT;
    const calculatedExcludingVat = (amt * rate) / (100 + rate);
    const calculatedExcludingVatAmount = amt - calculatedExcludingVat;

    setVATAmount(calculatedVAT);
    setIncludingVat(totalIncludingVat);
    setExcludingVat(calculatedExcludingVat);
    setExcludingVatAmount(calculatedExcludingVatAmount);
  };

  const handleReset = () => {
    setAmount("");
    setVATRate(15);
    setVATAmount(null);
    setIncludingVat(null);
    setExcludingVat(null);
    setExcludingVatAmount(null);
  };

  const buttonStyle = {
    flex: 1,
    padding: "10px 0",
    borderRadius: "8px",
    border: "none",
    background: "#4CAF50",
    color: "#fff",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "0.3s",
    textAlign: "center",
  };

  const hoverColor = "#FF5733";

  return (
    <div
      style={{
        minHeight: "80vh",
        background: "#F9F8F8",
        color: "#111",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "60px 10px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          rowGap: isMobile ? "40px" : "0",
          columnGap: "60px",
          alignItems: "stretch",
        }}
      >
        {/* LEFT SECTION */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <div>
            <div style={{ marginBottom: "20px" }}>
<h2
  style={{
    fontSize: "28px",
    fontWeight: 700,
    margin: "0 0 10px 0",
    fontFamily: "Domine, serif",
    padding: "0",
    background: "none",
    border: "none" // remove any borders
  }}
>
  VAT Return Submission
</h2>


              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#006400",
                  margin: 0,
                }}
              >
                With Certified VAT Consultant
              </h3>
            </div>

            <p
              style={{
                fontSize: "16px",
                lineHeight: 1.7,
                fontWeight: 400,
                maxWidth: "500px",
                margin: "0 0 30px 0",
              }}
            >
              We provide monthly VAT return submission and documentation services
              for your business. As per rules you need to file monthly VAT
              submission within 15 days of each month, otherwise VAT authority
              will fine five thousand BDT. <br />
              Also, we can help to submit your withholding Tax filling and
              foreign equity company FDI reporting to the bank.
              <br />
              <br />
              <strong style={{ color: "black" }}>
                Please comply with the rules of VAT department - NBR.
              </strong>
            </p>
          </div>

          <button
  style={{
    ...buttonStyle,
    width: "fit-content",
    padding: "8px 20px",
    marginBottom: "40px",
  }}
  onMouseOver={(e) => (e.currentTarget.style.background = hoverColor)}
  onMouseOut={(e) => (e.currentTarget.style.background = "#4CAF50")}
  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send/?phone=01511404971&text&type=phone_number&app_absent=0",
      "_blank"
    )
  }
>
  Contact Us Today
</button>

        </div>

        {/* RIGHT SECTION */}
        <div
          style={{
            width: "100%",
            height: "100%",
            padding: "30px",
            borderRadius: "15px",
            background: "#fafafa",
            border: "2px solid green",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <h1
            style={{
              fontSize: "26px",
              fontWeight: 700,
              color: "#222",
              padding: "8px",
              border: "2px solid green",
              borderRadius: "10px",
              display: "inline-block",
              margin: "0 auto 20px auto",
            }}
          >
            VAT Calculator
          </h1>

          <div
            style={{
              width: isMobile ? "100%" : "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: isMobile ? "center" : "stretch",
            }}
          >
            {/* Amount */}
            <div style={{ marginBottom: "16px", width: isMobile ? "100%" : "100%" }}>
              <label
                htmlFor="amount"
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: "#333",
                  fontWeight: 600,
                }}
              >
                Total Amount
              </label>
              <input
                id="amount"
                type="number"
                value={amount}
                placeholder="Enter total amount"
                onChange={(e) => setAmount(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  border: "1px solid green",
                  background: "#fff",
                  color: "#111",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* VAT Rate */}
            <div style={{ marginBottom: "20px", width: isMobile ? "100%" : "100%" }}>
              <label
                htmlFor="vatRate"
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: "#333",
                  fontWeight: 600,
                }}
              >
                VAT Rate (%)
              </label>
              <input
                id="vatRate"
                type="number"
                value={vatRate}
                onChange={(e) => setVATRate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  border: "1px solid green",
                  background: "#fff",
                  color: "#111",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Buttons */}
            <div
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "10px",
                flexDirection: isMobile ? "column" : "row",
                width: "100%",
              }}
            >
              <button
                onClick={calculateTotal}
                style={buttonStyle}
                onMouseOver={(e) => (e.currentTarget.style.background = hoverColor)}
                onMouseOut={(e) => (e.currentTarget.style.background = "#4CAF50")}
              >
                Calculate
              </button>
              <button
                onClick={handleReset}
                style={buttonStyle}
                onMouseOver={(e) => (e.currentTarget.style.background = hoverColor)}
                onMouseOut={(e) => (e.currentTarget.style.background = "#4CAF50")}
              >
                Reset
              </button>
            </div>

            {/* Results */}
            {VATAmount !== null && (
              <div style={{ marginTop: "20px", width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <span>VAT Amount</span>
                  <span>{VATAmount.toFixed(2)}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <span>Including VAT Amount</span>
                  <span>{includingVat.toFixed(2)}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <span>Excluding VAT</span>
                  <span>{excludingVat.toFixed(2)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Excluding VAT Amount</span>
                  <span>{excludingVatAmount.toFixed(2)}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VATCalculator;
